// extracted by mini-css-extract-plugin
export default {"resultsTables":"index-module__resultsTables--NZPYD","heading":"index-module__heading--M2Yzh"};